<template>  
    <div class="card-orcamento-informacao">
      <g-card :temCabecalho="false" :expansivel="false" :temBordaTopProps="this.tituloDetalhes">      
        <div v-if="tituloDetalhes" class="header-detalhes-secundario cabecalho-detalhes">        
          <div class="header-detalhes-secundario-titulo">          
            <g-button
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            altura="30px"
            cor="#FFFFFF"
            :sombreado="false"
            @click="voltar()"/>          
            
            <div class="titulo-detalhes-cabecalho"> Detalhes Orçamento - {{ numeroSolicitacao }}</div>        
          </div>        
          <div class="header-icons">          
            <g-button
            largura="38px"
            altura="36px"
            tamanhoIcone="18px"
            negritoTexto
            icone="icone_compartilhar.svg"/>          
            <g-button
            largura="38px"
            altura="36px"
            tamanhoIcone="18px"
            negritoTexto
            v-on:acao="imprimir"
            icone="icone_print.svg"/>        
          </div>      
        </div>      
        
        <div class="conteudo-card-orcamento-informacao espacamento-detalhes">        
          <div class="parametros-titulo titulo-grupo-detalhes"> PARÂMETROS </div>        
          <div class="grupo-parametros">          
            <div class="parametros-numero-solicitacao">            
              <div class="titulo-conteudo-detalhes"> Nº Solicitação </div>            
              <div class="label-conteudo">{{ numeroSolicitacao }}</div>          
            </div>          
            
            <div class="parametros-unidade">            
              <div class="titulo-conteudo-detalhes"> Unidade </div>            
              <div class="label-conteudo">{{ nomeEmpresa }}</div>          
            </div>          
            
            <div class="parametros-representante">            
              <div class="titulo-conteudo-detalhes"> Representante </div>            
              <div class="label-conteudo">{{ nomeRepresentante }}</div>          
            </div>          
            
            <div class="parametros-data-digitacao">            
              <div class="titulo-conteudo-detalhes"> Data Digitação </div>           
              <div class="label-conteudo">{{ dataDigitacaoFormatadaConsulta }}</div>          
            </div>          
            
            <div class="parametros-data-retorno">            
              <div class="titulo-conteudo-detalhes"> Data Retorno </div>            
              <div class="label-conteudo">{{ dataAlteracao }}</div>          
            </div>          
            
            <div class="parametros-status">            
              <div class="titulo-conteudo-detalhes"> Status </div>            
              <div class="label-conteudo">{{ statusText }}</div>          
            </div>        
          </div>        
          
          <div class="titulo-grupo-detalhes"> CLIENTE </div>        
          <div class="grupo-cliente">          
            <div class="cliente-cnpj">            
              <div class="titulo-conteudo-detalhes"> CNPJ </div>            
              <div class="label-conteudo">{{ cnpj }}</div>          
            </div>          
            
            <div class="cliente-codigo">            
              <div class="titulo-conteudo-detalhes"> Código </div>            
              <div class="label-conteudo">{{ codigoUsuario }}</div>          
            </div>          
            
            <div class="cliente-razao-social">            
              <div class="titulo-conteudo-detalhes"> Razão Social </div>            
              <div class="label-conteudo">{{ razaoSocial }}</div>          
            </div>          
            
            <div class="cliente-estado">            
              <div class="titulo-conteudo-detalhes"> Estado </div>            
              <div class="label-conteudo">{{ siglaEstado }}</div>          
            </div>         
            
            <div class="cliente-cidade">            
              <div class="titulo-conteudo-detalhes"> Cidade </div>            
              <div class="label-conteudo">{{ nomeCidade }}</div>          
            </div>         
            
            <div class="cliente-segmento">            
              <div class="titulo-conteudo-detalhes"> Segmento </div>            
              <div class="label-conteudo">{{ segmentoFormat }}</div>          
            </div>          
            
            <div class="cliente-contato">            
              <div class="titulo-conteudo-detalhes"> Contato </div>            
              <div class="label-conteudo">{{ nomeContato || "Não cadastrado" }}</div>          
            </div>          
            
            <div class="cliente-telefone">            
              <div class="titulo-conteudo-detalhes"> Telefone </div>            
              <div class="label-conteudo">{{ numeroTelefone || numeroCelular }}</div>          
            </div>          
            
            <div class="cliente-ramal">            
              <div class="titulo-conteudo-detalhes"> Ramal </div>            
              <div class="label-conteudo">{{ numeroRamal || "Não Possui" }}</div>          
            </div>          
            
            <div class="cliente-suframa">            
              <div class="titulo-conteudo-detalhes"> Suframa </div>            
              <div class="label-conteudo">{{ numeroSuframa || "Não Possui" }}</div>          
            </div>          
          
            <div class="cliente-incentivo-fiscal">            
              <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal? </div>            
              <div class="label-conteudo">{{icms + ipi + piscofins == "" ? "NÃO" : icms + ipi + piscofins}}</div>          
            </div>        
          </div>             
          
        <div class="html2pdf__page-break" />

        <div class="titulo-grupo-detalhes edita-titulo-componentes" v-if="componentesLista.length > 0"> COMPONENTES </div>
        <div class="lado_a_lado">
          <div class="agrupa_tudo" v-for="(data, index) in componentesLista" :key="index">
            <div class="grupo-componentes-numero">
              <div class="numero label-conteudo">{{ index+1 }}</div> 
            </div>
            <div class="grupo-componentes">          
              <div class="componentes-componentes">
                <div class="componentes titulo-conteudo-detalhes"> Componentes </div>
                <div class="componentes label-conteudo">{{ data.componenteTipoTexto }}</div>
              </div>
          
              <div class="componentes-medidas">
                <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                <div class="medidas label-conteudo">{{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? data.ColunaMedidas : data.descricaoMedidasTexto }}</div>
              </div>
          
              <div class="componentes-cor-frente">
                <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                <div class="corFrente label-conteudo">{{ data.descricaoCoresFrenteTexto }}</div>
              </div>
          
              <div class="componentes-cor-verso">
                <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                <div class="corVerso label-conteudo">{{ data.descricaoCoresVersoTexto }}</div>
              </div>
          
              <div class="componentes-acabFrente">
                <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
              </div>
          
              <div class="componentes-acabVerso">
                <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
              </div>
          
              <div class="componentes-material">
                <div class="material titulo-conteudo-detalhes"> Material </div>
                <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
              </div>
              <div class="componentes-onda">
                <div class="onda titulo-conteudo-detalhes"> Onda </div>
                <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
              </div>
              <div class="componentes-capaExt">
                <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
              </div>
          
              <div class="componentes-gramaturaExt">
                <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura Capa Externa</div>
                <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
              </div>
              <div class="componentes-papelOnda">
                <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
              </div>
          
              <div class="componentes-gramaturaPO">
                <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura Papel de Onda</div>
                <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
              </div>
              <div class="componentes-capaInt">
                <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
              </div>
          
              <div class="componentes-gramaturaInt">
                <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura Capa Interna</div>
                <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
              </div>

              <div v-if = "data.descricaoSistema == 0">
                  <div class="componentes-codigo">
                      <div class="titulo-conteudo-resumo-final"> Código </div>
                      <div class="label-conteudo-resumo-final">{{data.codigoSistema}}</div>
                  </div>
              </div>
          
                  <div v-if = "data.descricaoSistema == 0">
                    <div class="componentes-codigo">
                      <div class="titulo-conteudo-resumo-final"> Descrição Sistema</div>
                      <div class="label-conteudo-resumo-final">{{data.sistema}}</div>
                    </div>
                  </div>
                 <div v-else-if = "data.descricaoSistema == 2">
                    <div class="componentes-codigo">
                      <div class="titulo-conteudo-resumo-final"> Produto </div>
                      <div class="label-conteudo-resumo-final">{{data.produtoSistema}}</div>
                  </div>
                </div>
                <div v-else-if = "data.descricaoSistema == 3">
                    <div class="componentes-codigo">
                      <div class="titulo-conteudo-resumo-final"> Protótipo </div>
                      <div class="label-conteudo-resumo-final">{{data.prototipoSistema}}</div>
                </div>

              </div>

              <div class="componentes-embalagem-coletiva" 
                v-if="  data.embalagemEspecificaPalete == true || 
                        data.embalagemEspecificaFilmeEncolhivel == true || 
                        data.embalagemEspecificaCaixaColetiva == true || 
                        data.embalagemEspecificaPapelEmbrulho == true">
                    <div class="titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                    <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index">
                            {{ texto }}
                    </div>
              </div>

            </div>
          </div>
        </div>
        <div class="titulo-grupo-detalhes"> MOTIVO DA SOLICITAÇÃO DE ALTERAÇÃO </div>        
          <div class="s">          
            <div class="">            
              <div class="titulo-conteudo-detalhes"> Motivo </div>            
              <div class="resultado-observacao conteudo-observacao">{{ observacoesRetorno }}</div>          
            </div>    
          </div>                  
        </div>
        
        
      </g-card>  
    </div>
    <g-pdf :pdfFloat="false" :NovaGuia="true"  :executar="executarvisualizacao">
      <div>
        <div class="container-logo">
          <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
        </div>
      </div>
      <div class="render" v-if="renderiza">
        <ConsultarOrcamentoPDF :tituloDetalhes="false" v-on:termino="gerarPdf" :orcamentoId="OrcamentoSelecionado"></ConsultarOrcamentoPDF>
      </div>
    </g-pdf>
  </template>
      
  <script>
  import OrcamentoPendenteInformacao from "./OrcamentoPendenteInformacao.js";
  export default OrcamentoPendenteInformacao;
  </script>
  

  <style scoped>
.observacao-produto{
  font-family: monospace;
  max-width: 50ch;
  white-space: break-spaces;
}
.resultado-observacao{
  text-align: left;
  letter-spacing: 0px;
  color: #8a8a8a;
  opacity: 1;
  font-size: 16px;
}

.conteudo-observacao{
  font-family: monospace;
  max-width: 67ch;
  white-space: pre-wrap;
  text-align: initial;
}
.agrupa_tudo{
  display: flex;
    gap: 1rem;
    border-bottom: 2px solid #c4bfbf4d;
}
.grupo-componentes-numero{
  margin: auto;
    flex: 1;
    text-align: center;
    justify-content: center;
    align-items: center;
}
.img-info-mobile {
  font-size: 13px;
  font-family: "MontSerrat";
  letter-spacing: 0px;
  color: #CECECE;
  width: auto;
  margin: 10px 10px;
}
.container-logo{
  padding: 30px 30px 10px 53px;
}
.input-checkbox {
  padding: 1px 0;
}

.linha-separacao {
  margin: 15px 0;
}

.edita-titulo-componentes {
  border-bottom: none;
}

.critica-container{
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (min-width: 310px) {
.grupo-loteFrete{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, auto);
  column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 9 / 1 / 10 / 2;}
.orcamento-tabela {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 50px;
}

.infoBasicas-quantidade-data {
  display: flex;
  flex-direction: column;
  column-gap: 20px;
}

.grupo-infoBasicas {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(v-bind(RetornaQtdLinha1()), auto);
  grid-column-gap: 20px;
}
.infoBasicas-imagemProduto { grid-area: 1 / 1 / 3 / 2; }
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto1()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData1()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef1()) }
}

@media (min-width: 400px) {
.grupo-loteFrete{
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(5, auto);
  column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 5 / 1 / 6 / 2;}
.loteFrete-frete{grid-area: 3 / 1 / 4 / 2;}
.loteFrete-cep{grid-area: 3 / 2 / 4 / 3;}
.loteFrete-cidade{grid-area: 4 / 1 / 5 / 2;}
.loteFrete-estado{grid-area: 4 / 2 / 5 / 3;}
.infoBasicas-quantidade-data {
  display: grid;
  grid-template-columns: 30% auto;
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
}

@media (min-width: 500px) {
.grupo-parametros {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.parametros-numero-solicitacao { grid-area: 1 / 1 / 2 / 2; }
.parametros-unidade { grid-area: 1 / 2 / 2 / 3; }
.parametros-representante { grid-area: 2 / 1 / 3 / 2; }
.parametros-data-digitacao { grid-area: 2 / 2 / 3 / 3; }
.parametros-data-retorno { grid-area: 3 / 1 / 4 / 2; }
.parametros-status { grid-area: 3 / 2 / 4 / 3; }

.grupo-cliente {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(6, auto);
  grid-column-gap: 20px;
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 2 / 1 / 3 / 2; }
.cliente-estado { grid-area: 2 / 2 / 3 / 3; }
.cliente-cidade { grid-area: 3 / 1 / 4 / 2; }
.cliente-segmento { grid-area: 3 / 2 / 4 / 3; }
.cliente-contato { grid-area: 4 / 1 / 5 / 2; }
.cliente-telefone { grid-area: 4 / 2 / 5 / 3; }
.cliente-ramal { grid-area: 5 / 1 / 6 / 2; }
.cliente-suframa { grid-area: 5 / 2 / 6 / 3; }
.cliente-incentivo-fiscal { grid-area: 6 / 1 / 7 / 2; }

.grupo-componentes {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(10, auto);
  grid-column-gap: 20px;
  border-top: 1px solid #f0f0f0;
  padding: 10px;
  flex: 15
}


.grupo-orcamento {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.orcamento-porcentagem-financeira { grid-area: 1 / 1 / 2 / 2; }
.orcamento-prazo-maximo { grid-area: 1 / 2 / 2 / 3; }
.orcamento-forma-pagamento { grid-area: 2 / 1 / 3 / 2; }
.orcamento-gramatura { grid-area: 2 / 2 / 3 / 3; }
.orcamento-data-hora { grid-area: 3 / 1 / 4 / 2; }
}

@media (min-width: 600px) {
.grupo-loteFrete{
display: grid;
grid-template-columns: repeat(3, minmax(4em, 1fr));
grid-template-rows: repeat(4, auto);
column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 4 / 2 / 5 / 3;}
.loteFrete-frete{grid-area: 3 / 1 / 4 / 2;}
.loteFrete-cep{grid-area: 3 / 2 / 4 / 3;}
.loteFrete-cidade{grid-area: 3 / 3 / 4 / 4;}
.loteFrete-estado{grid-area: 4 / 1 / 5 / 2;}

}

@media (min-width: 700px) {
.checkbox-filtros {
  flex-direction: column;
}

.grupo-parametros {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.parametros-representante { grid-area: 1 / 3 / 2 / 4; }
.parametros-data-digitacao { grid-area: 2 / 1 / 3 / 2; }
.parametros-data-retorno { grid-area: 2 / 2 / 3 / 3; }
.parametros-status { grid-area: 2 / 3 / 3 / 4; }

.grupo-cliente {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(11, auto);
}
.cliente-razao-social { grid-area: 1 / 3 / 2 / 4; }
.cliente-estado { grid-area: 2 / 1 / 3 / 2; }
.cliente-cidade { grid-area: 2 / 2 / 3 / 3; }
.cliente-segmento { grid-area: 2 / 3 / 3 / 4; }
.cliente-contato { grid-area: 3 / 1 / 4 / 2; }
.cliente-telefone { grid-area: 3 / 2 / 4 / 3; }
.cliente-ramal { grid-area: 3 / 3 / 4 / 4; }
.cliente-suframa { grid-area: 4 / 1 / 5 / 2; }
.cliente-incentivo-fiscal { grid-area: 4 / 2 / 5 / 3; }

.grupo-infoBasicas {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind(RetornaQtdLinha2()), auto);
}
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto2()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData2()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef2()) }

.grupo-componentes {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.grupo-orcamento {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.orcamento-forma-pagamento { grid-area: 1 / 3 / 2 / 4; }
.orcamento-gramatura { grid-area: 2 / 1 / 3 / 2; }
.orcamento-data-hora { grid-area: 2 / 2 / 3 / 3; }
}

@media (min-width: 801px) {
.grupo-loteFrete{
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 3 / 1 / 4 / 2;}
.loteFrete-frete{grid-area: 2 / 1 / 3 / 2;}
.loteFrete-cep{grid-area: 2 / 2 / 3 / 3;}
.loteFrete-cidade{grid-area: 2 / 3 / 3 / 4;}
.loteFrete-estado{grid-area: 2 / 4 / 3 / 5;}
.grupo-orcamento {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
}
.orcamento-gramatura { grid-area: 1 / 4 / 2 / 5; }
.orcamento-data-hora { grid-area: 2 / 1 / 3 / 2; }
}

@media (min-width: 1025px) {
  .lado_a_lado{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    
}
.grupo-loteFrete{
  display: grid;
  grid-template-columns: repeat(5, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
  column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 2 / 5 / 3 / 6;}
.loteFrete-frete{grid-area: 2 / 1 / 3 / 2;}
.loteFrete-cep{grid-area: 2 / 2 / 3 / 3;}
.loteFrete-cidade{grid-area: 2 / 3 / 3 / 4;}
.loteFrete-estado{grid-area: 2 / 4 / 3 / 5;}
.grupo-parametros {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
}
.parametros-data-digitacao { grid-area: 1 / 4 / 2 / 5; }
.parametros-data-retorno { grid-area: 2 / 1 / 3 / 2; }
.parametros-status { grid-area: 2 / 2 / 3 / 3; }


.grupo-cliente {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
}
.cliente-estado { grid-area: 1 / 4 / 2 / 5; }
.cliente-cidade { grid-area: 2 / 1 / 3 / 2; }
.cliente-segmento { grid-area: 2 / 2 / 3 / 3; }
.cliente-contato { grid-area: 2 / 3 / 3 / 4; }
.cliente-telefone { grid-area: 2 / 4 / 3 / 5; }
.cliente-ramal { grid-area: 3 / 1 / 4 / 2; }
.cliente-suframa { grid-area: 3 / 2 / 4 / 3; }
.cliente-incentivo-fiscal { grid-area: 3 / 3 / 4 / 4; }

.grupo-componentes {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(5, auto);
}


.grupo-demaisCaract {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.demaisCaract-gerais { grid-area: 1 / 1 / 2 / 2; }
.demaisCaract-embalagem { grid-area: 1 / 2 / 2 / 3; }
.demaisCaract-critica { grid-area: 2 / 1 / 3 / 3; }
.demaisCaract-observacoes { grid-area: 3 / 1 / 4 / 3; }


.grupo-orcamento {
  grid-template-columns: repeat(5, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.orcamento-gramatura { grid-area: 1 / 4 / 2 / 5; }
.orcamento-data-hora { grid-area: 1 / 5 / 2 / 6; }
}

@media (min-width: 1281px) {
.grupo-loteFrete{
  display: grid;
  grid-template-columns: repeat(5, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
  column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 2 / 5 / 3 / 6;}
.loteFrete-frete{grid-area: 2 / 1 / 3 / 2;}
.loteFrete-cep{grid-area: 2 / 2 / 3 / 3;}
.loteFrete-cidade{grid-area: 2 / 3 / 3 / 4;}
.loteFrete-estado{grid-area: 2 / 4 / 3 / 5;}
.grupo-infoBasicas {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind(RetornaQtdLinha2()), auto);
}
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto3()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData3()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef3()) }
}

@media (min-width: 1400px) {
.grupo-parametros {
  grid-template-columns: repeat(5, minmax(4em, 1fr));
  grid-template-rows: repeat(2, 1fr);
}
.parametros-data-retorno { grid-area: 1 / 5 / 2 / 6; }
.parametros-status { grid-area: 2 / 1 / 3 / 2; }


.grupo-cliente {
  grid-template-columns: repeat(5, minmax(4em, 1fr));
}
.cliente-cidade { grid-area: 1 / 5 / 2 / 6; }
.cliente-segmento { grid-area: 2 / 1 / 3 / 2; }
.cliente-contato { grid-area: 2 / 2 / 3 / 3; }
.cliente-telefone { grid-area: 2 / 3 / 3 / 4; }
.cliente-ramal { grid-area: 2 / 4 / 3 / 5; }
.cliente-suframa { grid-area: 2 / 5 / 3 / 6; }
.cliente-incentivo-fiscal { grid-area: 3 / 1 / 4 / 2; }

.grupo-demaisCaract {
  grid-template-columns: 1.5fr 1fr 2fr;
  grid-template-rows: repeat(2, auto);
}
.demaisCaract-critica { grid-area: 1 / 3 / 2 / 4; }
.demaisCaract-observacoes { grid-area: 2 / 1 / 3 / 5; }


.grupo-orcamento {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
}
}

@media (min-width: 1500px) {
.grupo-loteFrete{
    display: grid;
    grid-template-columns: repeat(5, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    column-gap: 3%;
}
.loteFrete-tipo-frete{grid-area: 2 / 5 / 3 / 6;}
.loteFrete-frete{grid-area: 2 / 1 / 3 / 2;}
.loteFrete-cep{grid-area: 2 / 2 / 3 / 3;}
.loteFrete-cidade{grid-area: 2 / 3 / 3 / 4;}
.loteFrete-estado{grid-area: 2 / 4 / 3 / 5;}

.grupo-infoBasicas {
  grid-template-columns: repeat(v-bind(RetornaQtdColuna()), minmax(4em, 1fr));
}

.grupo-componentes {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
}

}

@media (min-width: 1600px) {
.grupo-infoBasicas {
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: repeat(v-bind(RetornaQtdLinha4()), auto);
}
.infoBasicas-nome-produto { grid-area: v-bind(GridNomeProduto4()) }
.infoBasicas-quantidade-data { grid-area: v-bind(GridQtdData4()) }
.infoBasicas-amostraRef { grid-area: v-bind(GridAmostraRef4()) }
}

@media(min-width: 1700px){
  .lado_a_lado{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}
}

@media (min-width: 1800px) {
.grupo-parametros {
  grid-template-columns: repeat(7, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.parametros-status { grid-area: 1 / 6 / 2 / 7; }

.grupo-cliente {
  grid-template-columns: repeat(7, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.cliente-segmento { grid-area: 1 / 6 / 2 / 7; }
.cliente-contato { grid-area: 1 / 7 / 2 / 8; }
.cliente-telefone { grid-area: 2 / 1 / 3 / 2; }
.cliente-ramal { grid-area: 2 / 2 / 3 / 3; }
.cliente-suframa { grid-area: 2 / 3 / 3 / 4; }
.cliente-incentivo-fiscal { grid-area: 2 / 4 / 3 / 5; }


.grupo-componentes {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
}

.grupo-orcamento {
  grid-template-columns: repeat(7, minmax(4em, 1fr));
}
}

@media (min-width: 2000px) {
.grupo-demaisCaract {
  grid-template-columns: 1.5fr 1fr 2fr 1fr;
  grid-template-rows: repeat(2, auto);
}
}
</style>